<template>
  <div class="pg-index">
    <header class="pg-index__header">
      <h1 class="pg-index__title">Figma design system</h1>
      <p class="pg-index__intro">
        {{ stories.length }} components, each rendered with the tokens of the selected brand. Pick one from the sidebar
        or below — every component has its own URL, and the brand travels with it. The dot shows its Code Connect
        mapping: {{ connectedCount }} connected, {{ disabledCount }} commented out, {{ missingCount }} unmapped.
      </p>
    </header>

    <ul class="pg-index__grid">
      <li v-for="story in stories" :key="story.slug">
        <NuxtLink
          class="pg-index__card"
          :to="{ path: `/figma-playground/components/${story.slug}`, query: { brand: route.query.brand } }"
        >
          <span class="pg-index__card-top">
            <span class="pg-index__card-name">{{ story.name }}</span>
            <CodeConnectBadge :status="story.codeConnect" compact />
          </span>
          <span class="pg-index__card-slug">{{ story.slug }}</span>
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import CodeConnectBadge from '../../figma-playground/CodeConnectBadge.vue';
  import { stories } from '../../figma-playground/stories';

  const route = useRoute();

  const connectedCount = stories.filter((story) => story.codeConnect === 'connected').length;
  const disabledCount = stories.filter((story) => story.codeConnect === 'disabled').length;
  const missingCount = stories.filter((story) => story.codeConnect === 'missing').length;
</script>

<style lang="postcss" scoped>
  .pg-index__header {
    max-width: 44rem;
    margin-bottom: 2rem;
  }

  .pg-index__title {
    margin: 0 0 0.5rem;
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -0.02em;
  }

  .pg-index__intro {
    margin: 0;
    font-size: 0.875rem;
    line-height: 1.6;
    color: #727272;
  }

  .pg-index__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(13rem, 1fr));
    gap: 0.75rem;

    margin: 0;
    padding: 0;

    list-style: none;
  }

  .pg-index__card {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    padding: 0.875rem 1rem;
    border: 1px solid #e4e4e4;
    border-radius: 0.5rem;

    text-decoration: none;

    transition:
      border-color 0.15s,
      background-color 0.15s;

    &:hover {
      border-color: #d1d1d1;
      background: #fafafa;
    }
  }

  .pg-index__card-top {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    justify-content: space-between;
  }

  .pg-index__card-name {
    font-size: 0.875rem;
    font-weight: 600;
    color: #1a1a1a;
  }

  .pg-index__card-slug {
    font-family: 'SF Mono', 'Fira Code', Consolas, monospace;
    font-size: 0.6875rem;
    color: #929292;
  }
</style>
